// use object here in case we may need to extend other fields in the future
import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import { CampaignType } from '@bingads-webui-campaign-react/shell-ui-common';

const dynamicPermissions = _.result(config.get('permissions'), 'dynamic', {});
const { IsRenameHotelToLodgingEnabled } = dynamicPermissions;

export const campaignTypes = [
  {
    id: CampaignType.All,
    i18nKey: _TL_('All campaigns'),
  }, {
    id: CampaignType.Default,
    i18nKey: _TL_('Search campaigns'),
  }, {
    id: CampaignType.Shopping,
    i18nKey: _TL_('Shopping campaigns'),
  }, {
    id: CampaignType.Audience,
    i18nKey: _TL_('Audience campaigns'),
  }, {
    id: CampaignType.Smart,
    i18nKey: _TL_('Smart campaigns'),
  },
  {
    id: CampaignType.Hotel,
    i18nKey: IsRenameHotelToLodgingEnabled ? _TL_('Lodging campaigns') : _TL_('Hotel campaigns'),
  },
  {
    id: CampaignType.PerformanceMax,
    i18nKey: _TL_('Performance Max campaigns'),
  },
  {
    id: CampaignType.App,
    i18nKey: _TL_('App campaigns'),
  },
];
